"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.buildChildrenObject = function (children, childrenObject) {
    return React.Children.toArray(children).reduce(function (acc, child) {
        if (!React.isValidElement(child)) {
            return acc;
        }
        if (!child.type || !child.type.displayName) {
            return acc;
        }
        var name = child.type.displayName.split('.').pop();
        acc[name] = child;
        return acc;
    }, childrenObject || {});
};
exports.createComponentThatRendersItsChildren = function (displayName) {
    var Element = function (_a) {
        var children = _a.children;
        return typeof children === 'string'
            ? React.createElement('div', {}, children)
            : children;
    };
    Element.displayName = displayName;
    return Element;
};
exports.noop = function () { return null; };
exports.isReactElement = function (child, Element) {
    return child && child.type === Element;
};
exports.isStatelessComponent = function (Component) {
    return !(Component.prototype && Component.prototype.render);
};
//# sourceMappingURL=index.js.map